import type { RequestSponsoredAdsBody, SponsoredAdsResultsSplit } from './sponsoredAds';

import timedFetch from 'middleware/timedFetch';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';

export interface AmazonAdsResponse {
  requestId: string;
  impressionUrl: string;
  results: SponsoredAdsResultsSplit;
}

interface GetAmazonSponsoredAdsProps {
  body: RequestSponsoredAdsBody;
  endpointUrl: string;
  controller: AbortController;
  fetcher?: Function;
}

export function getAmazonSponsoredAds({
  body,
  endpointUrl,
  controller,
  fetcher = timedFetch('getSponsoredAds')
}: GetAmazonSponsoredAdsProps): Promise<AmazonAdsResponse> {
  const opts = {
    method: 'post',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': '*/*'
    },
    body: JSON.stringify(body),
    signal: controller.signal
  };

  return fetcher(`${endpointUrl}/sponsored-ads/v2/getAds`, opts).then(fetchErrorMiddleware);
}
